import { render, staticRenderFns } from "./NotificationSample.vue?vue&type=template&id=80d8bc76&"
import script from "./NotificationSample.vue?vue&type=script&lang=js&"
export * from "./NotificationSample.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSample.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NotificationSample.vue"
export default component.exports